import { render, staticRenderFns } from "./DocumentoFirma.vue?vue&type=template&id=946b5eca&"
import script from "./DocumentoFirma.vue?vue&type=script&lang=js&"
export * from "./DocumentoFirma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports